export default __webpack_public_path__ + "static/media/map-pin-location-now.810522e5.svg";